import React from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { AlertBottomBanner } from '@uniiverse/library/components/alert-bottom-banner'
import ChevronIcon from '@uniiverse/library/assets/icons/chevron.svg'

import locale from './locale'
const style = require('./CovidAlertBanner.css')

const COOKIE_NAME = 'cookiecovid_alert'

export const CovidAlertBannerComponent: React.FunctionComponent<InjectedIntlProps> = ({ intl }) => (
  <AlertBottomBanner
    title={intl.formatMessage(locale.covidHeaderTitle)}
    cookieDismissKey={COOKIE_NAME}
  >
    <span>
      {intl.formatMessage(locale.covidContentText)}
      &nbsp;
      <span className={style.learnMore}>
        <a href={generateLocalizedLinkForSupportPage(intl.locale)} target="_blank">
          <span>
            {intl.formatMessage(locale.covidLearnMore)}
            &nbsp;
            <ChevronIcon />
          </span>
        </a>
      </span>
    </span>
  </AlertBottomBanner>
)

// helper functions
function generateLocalizedLinkForSupportPage(locale = 'en') {
  let mappedLocale = locale

  // english (en) and norwegian (nb) map to different locale names on support.universe.com.
  // greek and dutch belgium support pages (el + nl-be) do not exist, use english instead.
  if (locale === 'en' || locale === 'el' || locale === 'nl-be') mappedLocale = 'en-us'
  else if (locale === 'nb') mappedLocale = 'no'

  return `https://support.universe.com/hc/${mappedLocale}/articles/360040477612-COVID-19-Coronavirus-Information`
}

export const CovidAlertBanner = injectIntl(CovidAlertBannerComponent)
